export const REQUIRES_ORG_SELECTION_KEY = 'REQUIRES_ORG_SELECTION';
export const POST_AUTH_REDIRECT_KEY = 'POST_AUTH_REDIRECT';
export const AUTH_EMAIL_KEY = 'AUTH_EMAIL';
export const PENDING_ORG_MFA_KEY = 'PENDING_ORG_MFA';

export function readRequiresOrgSelection() {
  const flag = localStorage.getItem(REQUIRES_ORG_SELECTION_KEY);
  if (flag === 'true') {
    return true;
  }

  return false;
}

export function setRequiresOrgSelection(requiresOrgSelection) {
  if (requiresOrgSelection) {
    localStorage.setItem(REQUIRES_ORG_SELECTION_KEY, 'true');
  } else {
    localStorage.removeItem(REQUIRES_ORG_SELECTION_KEY);
  }
}

export function clearRequiresOrgSelection() {
  localStorage.removeItem(REQUIRES_ORG_SELECTION_KEY);
}

export function setAuthEmail(email) {
  if (email) {
    sessionStorage.setItem(AUTH_EMAIL_KEY, email);
  }
}

export function readAuthEmail() {
  return sessionStorage.getItem(AUTH_EMAIL_KEY) || '';
}

export function clearAuthEmail() {
  sessionStorage.removeItem(AUTH_EMAIL_KEY);
}

export function readPendingOrgMfa() {
  return sessionStorage.getItem(PENDING_ORG_MFA_KEY) === 'true';
}

export function setPendingOrgMfaContext({ organizationId, organizationName, email }) {
  sessionStorage.setItem(PENDING_ORG_MFA_KEY, 'true');

  if (organizationId) {
    sessionStorage.setItem(
      `${PENDING_ORG_MFA_KEY}_CONTEXT`,
      JSON.stringify({
        organizationId,
        organizationName: organizationName || '',
        email: email || readAuthEmail(),
      }),
    );
  }
}

export function readPendingOrgMfaContext() {
  if (!readPendingOrgMfa()) {
    return null;
  }

  const raw = sessionStorage.getItem(`${PENDING_ORG_MFA_KEY}_CONTEXT`);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearPendingOrgMfa() {
  sessionStorage.removeItem(PENDING_ORG_MFA_KEY);
  sessionStorage.removeItem(`${PENDING_ORG_MFA_KEY}_CONTEXT`);
}

const AUTH_PUBLIC_PATHS = new Set(['/login', '/signup', '/forgot-password', '/select-organization']);

export function resolveSafePostAuthPath(path, defaultPath = '/events') {
  if (!path || path === '/') {
    return defaultPath;
  }

  const pathname = path.split('?')[0];

  if (AUTH_PUBLIC_PATHS.has(pathname) || pathname.startsWith('/signup')) {
    return defaultPath;
  }

  return path;
}

export function savePostAuthRedirect(path) {
  const safePath = resolveSafePostAuthPath(path);

  if (safePath) {
    sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, safePath);
  }
}

export function consumePostAuthRedirect(defaultPath = '/events') {
  const path = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);

  return resolveSafePostAuthPath(path, defaultPath);
}
